import React from "react";
import Swal from "sweetalert2";
import axios from "../../../axios/axios";
import UpdateTeam from "../UpdateTeam/UpdateTeam";

const Team = ({ team, index, isUpdate, setIsUpdate }) => {
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`/teams/${id}`);
          Swal.fire("Deleted!", "Your file has been deleted.", "success");
          setIsUpdate(!isUpdate);
        } catch (error) {
          Swal.fire("Error!");
        }
      }
    });
  };

  return (
    <tr>
      <th>{index + 1}</th>
      <th>{team?.name}</th>
      <th>{team?.email}</th>
      <td>{team?.designation}</td>
      <td>
        <img
          style={{
            height: "62px",
            width: "62px",
            borderRadius: "5px",
            objectFit: "cover",
          }}
          src={team?.image_url}
          alt={index + 1}
        />
      </td>
      <td style={{ minWidth: "100px" }}>
        <UpdateTeam
          team={team}
          index={index}
          isUpdate={isUpdate}
          setIsUpdate={setIsUpdate}
        />
        <button
          style={{
            backgroundColor: "red",
            border: "none",
            borderRadius: "5px",
            marginLeft: "5px",
          }}
          onClick={() => handleDelete(team?.id)}
        >
          <i
            style={{
              color: "white",
              padding: "7px 3px",
              fontSize: "15px",
            }}
            className="fa fa-trash-o"
          ></i>
        </button>
      </td>
    </tr>
  );
};

export default Team;
